













































import { Component, Vue, Prop,Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import fetch from "@/common/api/fetch";
import CONFIG from "@/common/config";
import { Ladder } from "@/common/interface/group_type";

import { ShareObjectInterface, SignatureData, AxiosPromiseData } from "@/common/interface";
import getUrlParam from '@/common/utils/getUrlParam';
import getActivityType from '@/common/utils/getActivityType';
import { pickHtmlTextContent } from '@/common/utils/dealWithString';

import { exchangeMsgToXcx, wechatSignUp } from "@/common/utils/wechatFunc";
import PageContent from "@/components/common/edit/PageContent.vue";
import GroupActivitySection from "@/components/groupType/index/GroupActivitySection.vue";

@Component({
  components: {
    "group-activity-section": GroupActivitySection,
    "page-content": PageContent
  }
})
export default class GroupListModal extends Vue {
  @Prop() show!: boolean;
  @Prop() count!: number;
  @Prop() seqNo!: number;
  @Prop() courseName!: string;

  @Getter("groupList") groupList!: Array<object>;
  @Getter("urlUid") urlUid!: string;
  @Getter("title") title!: string;
  @Getter("section") section!: any;
  @Getter("gradientColor") gradientColor!: any;
  @Getter("coverTiny") coverTiny!: string;
  @Getter("courseGroupList") courseGroupList!: Ladder[];
  @Getter("courseType") courseType!: string;

  @Getter("signature") signature!: SignatureData;
  @Action("changeUrlUid") changeUrlUid!: Function;
  @Action("changeGroupList") changeGroupList!: Function;

  pageNo: number = 0;
  pageSize: number = 10;
  totalCount: number = this.count;
  @Watch('show', { immediate: true, deep: true })
  onChangeValue(newVal:boolean, oldVal:boolean) {
    if (getUrlParam('type') === 'share'&&newVal) {
      this.getGroupingList();
    }
  }
  handleCloseModal() {
    this.$emit("hide");
  }

  getGroupingList() {
    const param:any = {
      activityId: getUrlParam("broadcastId"),
      pageNo: 0,
      pageSize: this.pageSize
    };
    if (this.courseType === 'MANY') {
      param.seqNo = this.seqNo
    }
    fetch
      .newpost("anon/group/getGroupingList", param)
      .then((res: AxiosPromiseData) => {
        const { result = {} } = res;
        const { records = [], total = 0 } = result;
        this.changeGroupList(records);
        this.totalCount = Number(total);
      });
  }

  get filterGroupList(): Array<Object> {
    return this.groupList.filter((item: any) => item.groupDetailVOS[0].userId !== this.urlUid);
  }

  groupingListConcat() {
    this.pageNo = this.pageNo + 1;
    const param = {
      activityId: getUrlParam("broadcastId"),
      pageNo: this.pageNo,
      pageSize: this.pageSize
    };
    return fetch.newpost("anon/group/getGroupingList", param).then((res: AxiosPromiseData) => {
      const { result = {} } = res;
      const { records = [], total = 0 } = result;
      const newGroupList = this.filterGroupList.concat(records);
      this.changeGroupList(newGroupList);
      this.totalCount = Number(total);
    });
  }

  //去成团
  handleToOtherGroup(participatorId: string) {
    this.changeUrlUid(participatorId);
    this.handleCloseModal();
    const location =
      window.location.href
        .replace(/[?, &]code.*state/i, "")
        .replace(/&uid=\d*/, "") +
      "&uid=" +
      participatorId;
    this.signatureWechatShare(location);
    exchangeMsgToXcx(participatorId);
  }

  signatureWechatShare(location: string) {
    const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
    const shareObject: ShareObjectInterface = {
      title: this.title.replace(/<br\/>/g, "\n"),
      desc: pickHtmlTextContent(this.section.courseDesc),
      link:
        (CONFIG.shareUrl as any)[env] +
        (CONFIG.appId as any)[env] +
        "&redirect_uri=" +
        encodeURIComponent(location) +
        "&response_type=code&scope=" +
        (getActivityType() === "groupType"
          ? "snsapi_base"
          : "snsapi_base") +
        "&state=state#wechat_redirect",
      imgUrl: this.coverTiny
    };
    wechatSignUp(this.signature, shareObject);
  }

  groupLadder(group: any) {
    /**
     * applyNum: 已经报名人数
     * 团的最小阶梯成团数
     * maxGroupSize: 满团人数
     */
    const { applyNum, groupSize, maxGroupSize } = group;
    
    let status = "成团";
    let restSize = groupSize - applyNum;

    // maxGroupSize不存在说明不是阶梯拼团
    if (maxGroupSize) {
      // 已报名的人数大于等于第一个阶梯的成团数，说明已经成团了，但是没有满团
      if (applyNum >= Number(this.courseGroupList[this.seqNo - 1].ladderGroupList[0].groupSize)) {
        status = "满团";
        restSize = maxGroupSize - applyNum;
      } else {
        restSize = Number(this.courseGroupList[this.seqNo - 1].ladderGroupList[0].groupSize)- applyNum;
      }
    }
    return {
      status,
      restSize
    };
  }
}
